import { NgZone } from '@angular/core';
import { ɵAngularFireSchedulers } from '@angular/fire';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { environment } from '../environments/environment';
import { DEFAULT_INSTANCE_COMPANY_ID } from './shared/constants/storage-keys.constants';
import { safeStorageGet } from './shared/utils/safe-storage';

export class AngularFireAuthFactory {
  private platformId: Object;
  private zone: NgZone;
  private angularFireAuth: AngularFireAuth;
  private instances: Object;

  constructor(
    platformId: Object,
    zone: NgZone,
    angularFireAuth: AngularFireAuth
  ) {
    this.platformId = platformId;
    this.zone = zone;
    this.angularFireAuth = angularFireAuth;
    this.instances = {};
  }

  getInstance(companyId: string | null): AngularFireAuth {
    if (!companyId) {
      return this.angularFireAuth;
    }

    const instanceName = safeStorageGet(DEFAULT_INSTANCE_COMPANY_ID);
    if (instanceName !== null && instanceName === companyId) {
      return this.angularFireAuth;
    }

    if (!Object.keys(this.instances).includes(companyId)) {
      this.instances[companyId] = new AngularFireAuth(
        environment.firebase,
        companyId,
        this.platformId,
        this.zone,
        new ɵAngularFireSchedulers(this.zone),
        null,
        null,
        null,
        null,
        null,
        null,
        null
      );
    }
    return this.instances[companyId];
  }
}
